import { useState, useCallback } from 'react';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import { useSpinner } from '@chikara/ui';
import { useAsyncGuard } from '@chikara/hooks';
import { t } from '@/i18n';


export const useSetPassword = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);
    const { checkGuard: summaryGuard, resetGuard: resetSummaryGuard } = useAsyncGuard(1000);

    // Acepta la invitación (mintea un password_token fresh) e inmediatamente
    // confirma la contraseña con ese token. El password_token se obtiene aquí,
    // justo antes del confirm, y NUNCA se cachea/persiste: cada submit hace su
    // propio accept para evitar reusar un token ya consumido.
    const setupPassword = useCallback(async (reference: string, newPassword: string): Promise<boolean> => {
        if (!summaryGuard()) return false;

        show();
        setError(null);
        try {
            const accepted = await onboardingService.acceptInvite(reference);
            const passwordToken = accepted?.data?.password_token;
            if (!passwordToken) throw new Error('missing_password_token');

            await onboardingService.setupPassword({
                token: passwordToken,
                new_password: newPassword,
            });
            return true;
        } catch (err) {
            setError(t('onboarding.setupPassword.error'));
            resetSummaryGuard();
            return false;
        } finally {
            hide();
        }
    }, [show, hide, summaryGuard, resetSummaryGuard]);

    return {
        setupPassword,
        isLoading: isSpinnerLoading,
        error
    };
};
